import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IContact } from "../models/Contact";
import { IEbayOffer } from "../models/EbayOffer";

export default function useOffers() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation(
    (offer: IEbayOffer) => post(`/part/offers`, offer),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  //Optional body to patch in things after the defaults
  const createDefaultOffer = useMutation(
    ({ partId, body }: { partId: string; body: any }) => post(`/part/offers/default/${partId}`, body),
    {
      onSuccess: () => {
        // queryClient.invalidateQueries(["parts", partId]);
        queryClient.invalidateQueries(["parts", "multiple"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const update = useMutation(
    (offer: IEbayOffer) => put(`/part/offers/${offer.id}`, offer),
    {
      onSuccess: (_, offer) => {
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["parts", offer.partDataId]);
        queryClient.invalidateQueries(["basket"]);
      },
    }
  );

  return {
    create,
    createDefaultOffer,
    update,
  };
}
